import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ProviderAdvice from './ProviderAdvice';
import ViewPatientData from './ViewPatientData';
import PainDataSchedule from './PainDataSchedule';
import ErrorBoundary from '../../ErrorBoundary';
class ViewPatientReport extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;

            var path = window.origin + "/my-jeeva/projectmgmt/view-patient-report";
            var path1 = window.origin + "/my-jeeva/projectmgmt/view-patient-report/";
            if (currentPath == path || currentPath == path1) {
                $("#episode").addClass('active');
            } else if (currentPath.includes('/projectmgmt/view-patient-report/pain-data') ||
                currentPath.includes('/projectmgmt/view-patient-report/pain-data/')) {
                $("#viewPainData").addClass('active');
            }
            else {
                $("#" + localStorage.getItem("admin-nav-bar-selection")).addClass('active')
            }
            $("#viewPainData,#episode")
                .on("click", function () {
                    $("#viewPainData,#episode")
                        .removeClass('active');
                    localStorage.setItem("admin-nav-bar-selection", $(this)[0].id);

                    $(this).addClass('active')

                })

            $("#episodes").on("click", function () {
                $("#jeevaInteraction,#hcahps-survey")
                    .removeClass('active');
                $("#jeevaInteraction").addClass('active');
            })

        })();
    }
    goBackFromViewPatient = () => {
        this.props.history.push({
            pathname: "/projectmgmt/reports",
        });
    }
    render() {
        return (
            <ErrorBoundary>
            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="content-header" >
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                    <img src="assets/images/arrow.svg"
                                        style={{ paddingRight: "30%", cursor: 'pointer' }}
                                        onClick={this.goBackFromViewPatient}
                                    />
                                </div>
                                <div className="col-sm-5">
                                    <h1 className="m-0 page-title">Patient Report</h1>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="border-bottom"></div>
                        <div className="tab-class">

                            <ul className="nav nav-tabs border-bottom navCluster">
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/view-patient-report" style={{ textDecoration: 'none', marginLeft: '3vw', marginRight: '3vw' }}>
                                    <li className="nav-link" id="episode" style={{ marginRight: '15px' }}>
                                        Episode
                                    </li></Link>
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/view-patient-report/pain-data" style={{ textDecoration: 'none', marginLeft: '3vw', marginRight: '3vw' }}>
                                    <li className="nav-link" id="viewPainData" style={{ marginRight: '15px' }}>
                                        View Episode Data
                                    </li></Link>



                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/view-patient-report/pain-data" component={ViewPatientData}></Route>

                    <Route path="/projectmgmt/view-patient-report" component={PainDataSchedule}></Route>
                </Switch>
            </div>
            </ErrorBoundary>
        );
    }
}
export default ViewPatientReport;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ViewPatientReport.js